export const PENDING_WORKOUT_KEY = 'trainer/pendingWorkout'

const VALID_PHASES = ['running', 'paused', 'overtime', 'stopped']

export function isValidCapture(x) {
    if (!x || typeof x !== 'object') return false
    if (!x.workout) return false
    if (!Array.isArray(x.samples) || !Array.isArray(x.events)) return false
    if (typeof x.elapsed !== 'number' || Number.isNaN(x.elapsed)) return false
    if (!VALID_PHASES.includes(x.phase)) return false
    return true
}

export function loadCapture(storage = localStorage) {
    try {
        const raw = storage.getItem(PENDING_WORKOUT_KEY)
        if (!raw) return null
        const parsed = JSON.parse(raw)
        return isValidCapture(parsed) ? parsed : null
    } catch (e) {
        return null
    }
}

export function buildCapture({ workout, ftp, startTime, samples, events, elapsed, timer, phase }) {
    return {
        workout,
        ftp,
        start_time: startTime,
        elapsed,
        timer,
        samples,
        events,
        phase,
        updated_at: Math.floor(Date.now() / 1000),
    }
}

export function saveCapture(capture, storage = localStorage) {
    try {
        const ok = storage.setItem(PENDING_WORKOUT_KEY, JSON.stringify(capture))
        return ok !== false
    } catch (e) {
        // Quota exceeded (or storage unavailable): the capture stays in memory,
        // so the save-from-memory path in LayoutTraining still works.
        return false
    }
}

export function clearCapture(storage = localStorage) {
    storage.removeItem(PENDING_WORKOUT_KEY)
}